'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restaurantsCoordinatesMedian = exports.currentOrderSelector = exports.orderTypeSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = require('reselect');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('@arreeba/ristoranti-lib/lib/constants');

var _time = require('../helpers/time');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderTypeSelector = exports.orderTypeSelector = (0, _reselect.createSelector)(function (state, props) {
  return props.params;
}, function (state) {
  return state.order;
}, function (params, orderState) {
  if (!params) {
    // if there are url params, we're in the widget
    // otherwise we're in native app
    return orderState.orderType;
  }
  return params.orderType;
});

var currentOrderSelector = exports.currentOrderSelector = (0, _reselect.createSelector)(function (state) {
  return state.order;
}, orderTypeSelector, function (state) {
  return state.user.currentUser ? state.user.currentUser.orders : [];
}, function (state) {
  return state.user.archivedOrderId;
}, function (order, orderType, archivedOrders, archivedOrderId) {
  if (archivedOrderId) {
    var archived = _lodash2.default.find(archivedOrders, { id: archivedOrderId });
    var orderDate = archived.status === _constants.ORDER_STATUS_CONFIRMED ? archived.confirmation.date : archived.date;
    var timeDate = _time2.default.splitISO(orderDate);
    return _extends({}, archived, {
      cart: archived.items,
      orderType: archived.type,
      deliveryDate: timeDate.date,
      deliveryTime: timeDate.time
    });
  }
  return _extends({}, order, { orderType: orderType });
});

var median = function median(xMin, xMax) {
  return xMin + (xMax - xMin) / 2;
};

var restaurantsCoordinatesMedian = exports.restaurantsCoordinatesMedian = (0, _reselect.createSelector)(function (state) {
  return state.app.merchant.restaurants;
}, function (restaurants) {
  if (restaurants.length === 1) {
    return {
      lat: restaurants[0].location.latitude,
      lng: restaurants[0].location.longitude
    };
  }
  var defaultVal = { min: 999999, max: -999999 };
  var extr = restaurants.reduce(function (prev, res) {
    return {
      lat: {
        min: Math.min(prev.lat.min, res.location.latitude),
        max: Math.max(prev.lat.max, res.location.latitude)
      },
      lng: {
        min: Math.min(prev.lng.min, res.location.longitude),
        max: Math.max(prev.lng.max, res.location.longitude)
      }
    };
  }, { lat: defaultVal, lng: defaultVal });

  return {
    lat: median(extr.lat.max, extr.lat.min),
    lng: median(extr.lng.max, extr.lng.min)
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/common.js
// module id = 88
// module chunks = 0